import { HttpMethodEnum } from "../../data/models/HttpMethodEnum";
import { BaseApi } from "../../utils/BaseApi";
import { InfoPlanModel } from "../models/Soul/PlanModel";
import { SoulDataModel } from "../models/Soul/SoulDataModel";
import { SoulLoginParams } from "../models/Soul/SoulLoginParams";

export class SoulApi extends BaseApi {
  private static instance: SoulApi;

  public static get(): SoulApi {
    if (!this.instance) {
      this.instance = new SoulApi();
    }
    return this.instance;
  }

  public soulLogin = BaseApi.createEndpoint<null, SoulLoginParams>(
    HttpMethodEnum.POST,
    "/soul/login"
  );

  public soulInfo = BaseApi.createEndpoint<SoulDataModel, null>(
    HttpMethodEnum.GET,
    "/soul"
  );

  public soulPlan = BaseApi.createEndpoint<InfoPlanModel, null>(
    HttpMethodEnum.GET,
    "/soul/plan"
  );
}

export const soulApi = SoulApi.get();
